import setGrabCursor from './setGrabCursor';
import unsetGrabCursor from './unsetGrabCursor';
export default {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/esm/components/core/grab-cursor/index.js
// module id = null
// module chunks = 